// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__vefgV","content":"Footer_content__E5BS0","logo":"Footer_logo__ZCKFh"};